import { Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './menu.html',
  styleUrl: './menu.css'
})
export class AppMenu {
  @Input({ transform: (v: unknown) => !!v }) collapsed: boolean = false;

  protected readonly items = [
    { icon: 'apartment', label: 'menu.business_partners', path: 'business-partners' },
    { icon: 'group', label: 'menu.users', path: 'users' },
    { icon: 'dns', label: 'menu.providers', path: 'providers' },
    { icon: 'local_shipping', label: 'menu.carriers', path: 'carriers' },
    { icon: 'badge', label: 'menu.drivers', path: 'drivers' },
    { icon: 'insights', label: 'menu.metrics', path: 'metrics' },
    { icon: 'help', label: 'menu.help', path: 'help' }
  ];
}
